export default __webpack_public_path__ + "static/media/blend-graph-on1.12f85c85.svg";